//$(document).ready(function() {
//  // Init the filters for the skills map
//  var filters = {
//    grade: [],
//    subject: []
//  };
//  var resultsContainer = $('.search-results .results');
//
//  // Getting the filters from the url params
//  var path = location.pathname;
//  var params =$.grep(path.split('/'),function(n){ return n != ''});
//
//  if (params.length && params[0] == 'skills') {
//    // Getting the grade
//    if (params[1]) {
//      filters.grade = params[1];
//    }
//    // Getting the subject
//    if (params[2]) {
//      filters.subject = params[2];
//    }
//  }
//
//  /** Listener for the filters */
//  $('.search-filter').on('click', 'a[data-filter]', function() {
//    // Getting the type of filter selected
//    var type = $(this).data('type');
//    var filter = $(this).data('filter');
//  });
//});

(function($) {
  // var esr = function(options) {
  //   options = options || {};
  //   this.el = options.el || $('.search-results');
  //   this.options = options;
  //
  //   // Internal variables
  //   this.is_dirty = false;
  //   this.search_timer = 0;
  //   this.url = this.options.url || '';
  //   this.filters_disabled = false;
  //   this.ajaxParameters = this.options.ajaxParameters || {__call: 'OpenSearch'};
  //
  //   // DOM elements
  //   this.list = $(".results-list",this.el);
  //   this.facetHolder = $(".search-filter",this.el);
  //   this.searchTermInput = $("input.search-term",this.el);
  //   this.sortSelect = $("select.sort",this.el);
  //   this.clearLink = $(".clear-link",this.el);
  //   this.pagination = $(".pagination",this.el);
  //   this.statusMessage = $(".status-message",this.el);
  //   this.loadingOverlay = $(".loading",this.el);
  //   this.pagination = $(".pagination",this.el);
  //   this.formatOptions = $(".format-options",this.el);
  //   this.guidedLessons = $(".guided-lessons-container",this.el);
  //
  //   this.title = $(".title-area h1");
  //   this.description = $(".title-area p, .bottom-description p");
  //
  //   // Setup the search filters
  //   this.setupFilters();
  //
  //   // Add event listeners
  //   this.setupEvents();
  //
  //   // Update the UI
  //   this.refreshFilters();
  //
  //   // Set the initial page state
  //   if(window.history.replaceState) {
  //     window.history.replaceState(this.filter,document.title,window.location.href);
  //   }
  // };
  // esr.prototype = {
  //   setupFilters: function() {
  //     // Base filters take precedence over everything else
  //     this.base_filter = this.options.base_filter || {};
  //
  //     // Default filter values
  //     var defaults = this.options.default_filter || {};
  //
  //     // Holder for the current filter
  //     this.filter = {
  //       q: defaults.q || '',
  //       page: defaults.page || 1,
  //       typeahead: 0,
  //       resultsPerPage: defaults.resultsPerPage || 20,
  //       format: defaults.format || 'grid',
  //       sort: defaults.sort || 'dateCreated',
  //       types: defaults.types || [],
  //       facets: defaults.facets || []
  //     };
  //
  //     // If there's a search term, default to relevance sort
  //     if(!defaults.sort && this.filter.q.length) {
  //       this.filter.sort = 'relevance';
  //       this.is_dirty = true;
  //     }
  //
  //     this.defaultSort = this.options.default_sort || this.filter.sort;
  //
  //     // Replace fake facet links with real ones (fake links are to prevent SEO crawl fatigue)
  //     $('.facet-section a[data-href]',this.el).each(function() {
  //       $(this).attr('href',$(this).attr('data-href'));
  //     });
  //   },
  //   setupEvents: function() {
  //     var self = this;
  //
  //     // Cancel any form submits
  //     this.el.on('submit',function(e) {
  //       e.preventDefault();
  //     });
  //
  //     if(this.options.typeahead) {
  //       // Search as the user types
  //       this.searchTermInput.on('keyup',function() {
  //         // Don't search if value hasn't changed
  //         if(self.filter.q === $(this).val()) return;
  //
  //         // Update the filter
  //         self.is_dirty = true;
  //         self.filter.typeahead = 1;
  //         self.filter.page = 1;
  //         self.filter.q = $(this).val();
  //
  //         if(self.filter.q.length) {
  //           self.filter.sort = 'relevance';
  //         }
  //         else {
  //           self.filter.sort = self.defaultSort;
  //         }
  //
  //         // Delay searching by 300ms
  //         window.clearTimeout(self.search_timer);
  //         self.search_timer = window.setTimeout(function() {
  //           self.refresh();
  //         },300);
  //       });
  //     }
  //
  //     // Search when the user stops typing
  //     this.searchTermInput.on('change',function() {
  //       // Cancel any pending typeahead requests
  //       window.clearTimeout(self.search_timer);
  //       self.search_timer = 0;
  //
  //       // Original entered value
  //       var val = $(this).val();
  //
  //       // Strip out "%20" and similar encoding
  //       var sanitized = decodeURIComponent(val)
  //         // Replace '/' or '+' with space
  //         .replace(/[/+]/g,' ')
  //         // Trim whitespace
  //         .replace(/(^\s+|\s+$)/g,'');
  //
  //       // Treat the string 'null' as an empty string
  //       if(sanitized == 'null') sanitized = '';
  //
  //       // If the sanitized string is different from what was entered, update the input box
  //       if(sanitized !== val) {
  //         val = sanitized;
  //         $(this).val(sanitized);
  //       }
  //
  //       // Update the filter
  //       self.is_dirty = true;
  //       self.filter.typeahead = 0;
  //       self.filter.page = 1;
  //       self.filter.q = val;
  //
  //       if(self.filter.q.length) {
  //         self.filter.sort = 'relevance';
  //       }
  //       else {
  //         self.filter.sort = self.defaultSort;
  //       }
  //
  //       // Refresh results
  //       self.refresh(true);
  //     });
  //
  //     this.el.on('click','.facet-section .toggle-collapse',function(e) {
  //       e.preventDefault();
  //       if($(this).parent().hasClass('show-collapsed')) {
  //         $(this).parent().removeClass('show-collapsed');
  //         $(this).text('See All');
  //       }
  //       else {
  //         $(this).parent().addClass('show-collapsed');
  //         $(this).text('See Fewer');
  //       }
  //     });
  //
  //     this.el.on('click','.facet',function(e) {
  //       if(e) e.preventDefault();
  //       if(self.filters_disabled) return;
  //
  //       // Cancel any pending searches
  //       window.clearTimeout(self.search_timer);
  //       self.search_timer = 0;
  //
  //       // Get what type of facet this is (grade, subject, etc.)
  //       var type = $(this).attr('data-type');
  //
  //       var facet = self.filter.facets[type];
  //
  //       var value = $(this).attr('data-value');
  //       self.is_dirty = true;
  //       self.filter.typeahead = 0;
  //       self.filter.page = 1;
  //
  //       facet.selectedValues = facet.selectedValues || [];
  //       facet.allowedValues = facet.allowedValues || [];
  //
  //       var allowMultiple = facet.allowMultiple;
  //
  //       // If clicking on an already selected value, remove it
  //       if($(this).hasClass('selected')) {
  //         var new_values = [];
  //         var to_remove = [value];
  //
  //         var internalName = $(this).attr('data-internal-name');
  //
  //         // Deselect all children
  //         $('.facet[data-internal-name^="'+internalName+'."]',self.el).each(function() {
  //           to_remove.push($(this).attr('data-value'));
  //         });
  //
  //         // Select parent if there is one
  //         if(internalName.match(/\./)) {
  //           var parentInternalName = internalName.replace(/\.[^.]+$/,'');
  //           var parent = $('.facet[data-internal-name="'+parentInternalName+'"]',self.el);
  //           if(parent.length) {
  //             new_values.push(parent.attr('data-value'));
  //           }
  //         }
  //
  //         for(var i=0; i<self.filter.facets[type].selectedValues.length; i++) {
  //           var test = facet.selectedValues[i];
  //
  //           if($.inArray(test,new_values) >= 0) continue;
  //           if($.inArray(test,to_remove) >= 0) continue;
  //           new_values.push(test);
  //         }
  //
  //         facet.selectedValues = new_values;
  //       }
  //       // Otherwise, select the value
  //       else {
  //         // If we allow multiple
  //         // Or the user explicitly did shift+click or ctrl+click
  //         if(allowMultiple || e.metaKey || e.ctrlKey || e.shiftKey) {
  //           // If all the values are currently selected, set the new value to just this one
  //           if(allowMultiple && facet.selectedValues.length == facet.allowedValues.length) {
  //             facet.selectedValues = [value];
  //           }
  //           // Otherwise, add this selection to the current list
  //           else {
  //             facet.selectedValues.push(value);
  //           }
  //         }
  //         // Single value at a time
  //         else {
  //           facet.selectedValues = [value];
  //         }
  //       }
  //
  //       // Refresh results
  //       self.refresh(true);
  //     });
  //
  //     // When the sort dropdown changes
  //     this.sortSelect.on('change',function() {
  //       // Cancel any pending searches
  //       window.clearTimeout(self.search_timer);
  //       self.search_timer = 0;
  //
  //       // Update the filter
  //       var subject = $(this).attr('data-subject');
  //       self.is_dirty = true;
  //       self.filter.typeahead = 0;
  //       self.filter.page = 1;
  //       self.filter.sort = $(this).val();
  //
  //       // Refresh results and scroll to top
  //       self.refresh(false,true);
  //     });
  //
  //     // When the clear link is clicked
  //     this.clearLink.on('click',function(e) {
  //       if(e) e.preventDefault();
  //       self.clearFilters(true);
  //     });
  //
  //     this.el.on('click','.remove-filter',function(e) {
  //       if(e) e.preventDefault();
  //
  //       // Cancel any pending searches
  //       window.clearTimeout(self.search_timer);
  //       self.search_timer = 0;
  //
  //       var type = $(this).attr('data-type');
  //       if(type == 'searchTerm') {
  //         self.filter.q = '';
  //         $('.search-term').val('');
  //       }
  //       else if(type.match(/^facet-/)) {
  //         var facet = type.replace(/^facet-/,'');
  //
  //         var to_remove = $(this).attr('data-value');
  //
  //         var new_values = [];
  //         $.each(self.filter.facets[facet].selectedValues,function(k,v) {
  //           if(v != to_remove) new_values.push(v);
  //         });
  //         self.filter.facets[facet].selectedValues = new_values;
  //       }
  //       else {
  //         return;
  //       }
  //
  //       self.filter.typeahead = 0;
  //       self.filter.page = 1;
  //       self.is_dirty = true;
  //       self.refresh(true);
  //     });
  //
  //     // When pagination links are clicked
  //     this.pagination.on('click','.links a',function(e) {
  //       if(e) e.preventDefault();
  //
  //       // Cancel any pending searches
  //       window.clearTimeout(self.search_timer);
  //       self.search_timer = 0;
  //
  //       var page = $(this).attr('data-page')*1;
  //       self.filter.page = page;
  //       self.is_dirty = true;
  //
  //       // Refresh results and scroll to top
  //       self.refresh(true,true);
  //     });
  //
  //     // When a "did you mean" term is clicked
  //     this.list.on('click','.did-you-mean a',function(e) {
  //       var term = $(this).attr('data-term');
  //       if(!term) return;
  //       e.preventDefault();
  //
  //       self.filter.q = term;
  //       self.is_dirty = true;
  //       self.refresh(true);
  //     });
  //
  //     this.formatOptions.on('click','a',function(e) {
  //       e.preventDefault();
  //       if($(this).hasClass('selected')) return;
  //       self.filter.format = $(this).attr('data-format');
  //       self.is_dirty = true;
  //
  //       // Refresh results and scroll to top
  //       self.refresh(false,true);
  //     });
  //
  //     // Listen for state change events
  //     $(window).on('popstate',function(e) {
  //       // Cancel any pending searches
  //       window.clearTimeout(self.search_timer);
  //       self.search_timer = 0;
  //
  //       if(window.history.state && window.history.state.page) {
  //         if(JSON.stringify(window.history.state) != JSON.stringify(self.filter)) {
  //           self.filter = window.history.state;
  //           self.is_dirty = true;
  //
  //           // Refresh results
  //           self.refresh(false,false);
  //         }
  //       }
  //     });
  //   },
  //   clearFilters: function(addHistory) {
  //     // Reset search term
  //     this.filter.q = '';
  //
  //     // Reset facets
  //     var self = this;
  //     $.each(this.filter.facets, function(k) {
  //       self.filter.facets[k] = [];
  //     });
  //
  //     // Sorting by relevance doesn't make sense for an empty search term
  //     if(this.filter.sort === 'relevance') this.filter.sort = this.defaultSort;
  //
  //     this.filter.page = 1;
  //     this.filter.typeahead = 0;
  //     this.filter.types = [];
  //
  //     this.is_dirty = true;
  //
  //     this.refresh(addHistory);
  //   },
  //   refresh: function(addHistory, scroll) {
  //     var self = this;
  //
  //     this.refreshFilters();
  //
  //     // Don't do the search unless the filters have changed
  //     if(!this.is_dirty) return;
  //
  //     var params = $.extend({},this.filter,this.base_filter,this.ajaxParameters,true);
  //
  //     if(!params.typeahead) {
  //       this.loadingOverlay.show();
  //
  //       // Disable the filters while results are loading
  //       this.filters_disabled = true;
  //     }
  //
  //     for(var i in params.facets) {
  //       params.facets[i] = params.facets[i].selectedValues;
  //     }
  //
  //     // Some facets have their own special url parameters
  //     if(params.facets.grades) {
  //       params.grades = params.facets.grades;
  //       delete params.facets.grades;
  //     }
  //     if(params.facets.subjects) {
  //       params.subjects = params.facets.subjects;
  //       delete params.facets.subjects;
  //     }
  //     if(params.facets.types) {
  //       params.types = params.facets.types;
  //       delete params.facets.types;
  //     }
  //
  //     $.get('/',params,function(resp) {
  //       if(!resp.error && resp.filter) {
  //         self.is_dirty = false;
  //
  //         if(resp.filter) {
  //           self.filter.page = resp.filter.page;
  //           self.filter.facets = resp.filter.facets;
  //           self.filter.q = resp.filter.searchTerm;
  //           self.filter.format = resp.filter.format;
  //           self.filter.sort = resp.filter.sortField;
  //           self.filter.resultsPerPage = resp.filter.resultsPerPage;
  //
  //           // Replace left facet html
  //           $(".facet-section",self.el).remove();
  //           var new_facet_html = $(resp.facetHTML);
  //           $(".search-box",self.el).after($(".facet-section",new_facet_html));
  //
  //           // Replace fake facet links with real ones (fake links are to prevent SEO crawl fatigue)
  //           $('.facet-section a[data-href]',self.el).each(function() {
  //             $(this).attr('href',$(this).attr('data-href'));
  //           });
  //
  //           // Replace current filters (e.g. "Current Filter (23 results): [reading|x] [preschool|x]")
  //           $(".current-filters-holder",self.el).html(resp.currentFiltersHTML);
  //
  //           self.refreshFilters();
  //         }
  //
  //         self.pages = Math.ceil(resp.totalResults/self.filter.resultsPerPage);
  //         self.refreshPagination();
  //
  //         // Update title
  //         self.title.html(resp.meta.title);
  //         document.title = resp.meta.metaTitle;
  //
  //         // Hide description (stops the page from jumping around or showing stale description text)
  //         self.description.text(resp.meta.description).hide();
  //
  //         // Update meta description
  //         $("meta[name='description']").attr('content',resp.meta.metaDescription);
  //
  //         // Update robots
  //         $("meta[name='robots']").attr('content',resp.meta.index? "index,follow":"noindex,follow");
  //
  //         // Manage browser history if this isn't a typeahead refresh
  //         if(!params.typeahead) {
  //           if(addHistory && self.url && window.history.pushState) {
  //             window.history.pushState(self.filter,document.title,self.url+resp.url);
  //           }
  //           else if(self.url && window.history.replaceState) {
  //             window.history.replaceState(self.filter,document.title,self.url+resp.url);
  //           }
  //         }
  //
  //         // Update guided lessons area
  //         self.guidedLessons.html(resp.guidedLessonsHTML.template ||'');
  //
  //         // Update status message
  //         self.statusMessage.text(resp.statusMessage);
  //
  //         // Store current ads
  //         var ads = $('.ad-result',self.list).detach();
  //
  //         // Empty the results area
  //         self.list.html('');
  //
  //         // Did You Mean suggestions
  //         if(resp.suggestions && resp.suggestions.length) {
  //           var dym = $("<div class='did-you-mean alert'></div>");
  //           dym.append('<span>Did you mean:</span> ');
  //
  //           for(var i=0; i<resp.suggestions.length; i++) {
  //             if(i) dym.append(', ');
  //
  //             dym.append($("<a>")
  //               .html(resp.suggestions[i].highlighted)
  //               .attr('data-term',resp.suggestions[i].text)
  //             );
  //           }
  //
  //           self.list.append(dym);
  //         }
  //
  //         // No results
  //         if(!resp.numResults) {
  //           self.list.append("<em>Sorry, no results match your search.</em> ");
  //
  //           self.list.append($("<a>").text('Remove all filters').on('click',function() {
  //             self.clearFilters();
  //           }));
  //           self.list.append('.');
  //         }
  //         else {
  //           self.list.append(resp.html);
  //         }
  //
  //         // Put ads back into the search results at the proper spot
  //         var els = self.list.find('.result');
  //         ads.each(function() {
  //           var placement = $(this).attr('data-placement');
  //           if(placement >= els.length) {
  //             self.list.append($(this).addClass('extra-bottom'));
  //           }
  //           else {
  //             els.eq(placement).before($(this).removeClass('extra-bottom'));
  //           }
  //         });
  //
  //         $(window).trigger('refreshAds');
  //
  //         // Update format
  //         self.list.removeClass('grid list').addClass(self.filter.format);
  //         self.formatOptions.find('a').removeClass('selected');
  //         self.formatOptions.find('a[data-format="'+self.filter.format+'"]').addClass('selected');
  //       }
  //       else {
  //         self.list.html("<div class='alert alert-error'><strong>Unexpected Error:</strong> "+
  //           "Please try again in a few minutes and email support@education.com if you continue to experience issues. "+
  //           "We're sorry for any inconvenience."+
  //         "</div>");
  //         if(window.console && window.console.log) {
  //           console.log('error searching',resp);
  //         }
  //       }
  //
  //       // Hide loading overlay
  //       self.loadingOverlay.hide();
  //
  //       if(scroll) {
  //         // Scroll up to first result if we're already scrolled past it or too far up
  //         var target = self.el.offset().top - 5;
  //         if(target < $("body").scrollTop() || (target > $("body").scrollTop() + 150)) {
  //           // If this is a popstate refresh, scroll quicker
  //           // Because of browser behavior, we can't scroll immediately, so there still needs ot be some delay
  //           var delay = addHistory? 500 : 10;
  //
  //           $('html,body').animate({
  //             scrollTop: target
  //           },delay);
  //         }
  //       }
  //
  //       // Re-enable the filters
  //       self.filters_disabled = false;
  //
  //     }).fail(function() {
  //       self.list.html("<div class='alert alert-error'>There was an error searching for lesson plans.</div>");
  //
  //       // Hide the loading overlay and mobile filters
  //       self.loadingOverlay.hide();
  //       if($(".search-filter.open").length) {
  //         $(".search-filter.open .mobile-tab").trigger('click');
  //       }
  //
  //       // Re-enable the filters
  //       self.filters_disabled = false;
  //     });
  //   },
  //   refreshFilters: function() {
  //     var self = this;
  //
  //     // Update search term
  //     if(!this.filter.typeahead) {
  //       if(this.searchTermInput.val() !== this.filter.q) {
  //         this.searchTermInput.val(this.filter.q);
  //       }
  //     }
  //
  //     // Update the sort dropdown
  //     this.sortSelect.val(this.filter.sort);
  //   },
  //
  //   refreshPagination: function() {
  //     var holder = $(".links",this.pagination).empty();
  //
  //     var start, end;
  //     if(this.filter.page > 6) {
  //       start = this.filter.page - 5;
  //       end = Math.min(this.filter.page + 4, this.pages);
  //     }
  //     else {
  //       start = 1;
  //       end = Math.min(10,this.pages);
  //     }
  //
  //     // Update pagination counter
  //     this.pagination.attr('data-pages',this.pages);
  //
  //     // Add pagination links
  //     for(var i=start; i<=end; i++) {
  //       var el;
  //       if(i === this.filter.page) {
  //         el = $("<span class='current'>").text(i);
  //       }
  //       else {
  //         el = $("<a>")
  //           .attr('href','?page='+i)
  //           .attr('data-page',i)
  //           .text(i);
  //       }
  //       holder.append(el);
  //     }
  //   }
  // };
  //
  // if(window.OpenSearch && window.OpenSearch[0]) {
  //   window.OpenSearchResults = new esr(window.OpenSearch[0]);
  //   $(document).trigger('search-ready');
  // }
  //
  // window.OpenSearch = {
  //   push: function(options) {
  //     window.OpenSearchResults = new esr(options);
  //     $(document).trigger('search-ready');
  //   }
  // };
})(window.jQuery);
